import { Box, Typography } from '@mui/material';
import { OwnerType, TImportOwnerList, TOwner, TOwnerTypeStateAction } from '../../types';
import { ownerLabelText, ownerTypeOptions } from '../../constants';
import { AutocompleteField } from '~/components/AutocompleteField/AutocompleteField';
import { styles } from '../../styles';
import { useEffect, useState } from 'react';
import { errorMessages } from '~/constants/errorMessages';
import { TAutocompleteOption } from '~/components/AutocompleteField/types';

interface IImportOwnerCardProps {
  owner: TOwner;
  index: number;
  values?: TImportOwnerList;
  setOwnerTypeValues: TOwnerTypeStateAction;
  isSubmited: boolean;
}

const ImportOwnerCard = ({
  owner,
  index,
  values,
  setOwnerTypeValues,
  isSubmited,
}: IImportOwnerCardProps) => {
  const { lastName, firstName, middleName, fullName, shortNameUkr } = owner;
  const value = values?.[index] || null;
  const [isTriggered, setIsTriggered] = useState(false);
  const name =
    (fullName
      ? fullName || shortNameUkr
      : `${lastName || ''} ${firstName || ''} ${middleName || ''}`) || '';

  useEffect(() => {
    setOwnerTypeValues((prevValue) => ({
      ...prevValue,
      [index]: { value: owner.type, label: ownerLabelText[owner.type] },
    }));
  }, [owner.type]);

  const showError = (isTriggered || isSubmited) && !value?.value;
  const includesWithoutFormalOwnership = Object.values(values || {}).some(
    (item) => item?.value === OwnerType.BENEFICIARY_WITHOUT_FORMAL_OWNERSHIP
  );

  const options = includesWithoutFormalOwnership
    ? ownerTypeOptions.filter(
        (type) => type.value !== OwnerType.BENEFICIARY_WITHOUT_FORMAL_OWNERSHIP
      )
    : ownerTypeOptions;

  const handleChange = (newValue: TAutocompleteOption | null) => {
    setOwnerTypeValues((prevValue) => ({
      ...prevValue,
      [index]: newValue,
    }));
  };

  return (
    <Box sx={styles.importCard}>
      <Box>
        <Typography variant="h6">{name}</Typography>
        <Typography sx={{ color: 'gray', lineHeight: 1 }}>Запис з ЄДР</Typography>
      </Box>
      <AutocompleteField
        options={options}
        value={value}
        inputSlotProps={{
          htmlInput: {
            placeholder: 'Оберіть опцію',
            'data-testid': `owner-type-${value?.label}`,
          },
        }}
        label="Тип власника"
        disabled={!!owner.type}
        error={showError}
        helperText={showError ? errorMessages.OWNER_TYPE_REQUIRED : ''}
        sx={{
          width: '50%',
          minWidth: 220,
          pt: 1.5,
        }}
        onChange={handleChange}
        onBlur={() => setIsTriggered(true)}
      />
    </Box>
  );
};

export default ImportOwnerCard;
